import { UserActivityLogModel } from 'src/app/shared/models/userActivityLog.model';
import { WorkflowStepAssignedView } from './workflowStepAssignedView.model';
import { WorkflowSteps } from './workflowSteps.model';

export class WorkflowView
{
    workflowId:number;
    surveyId:string='';
    status:string;
    name:string;
    description:string
    isDeleted:boolean=false;
    workflowSteps:WorkflowSteps[]=[];
    //this property added to access step detail selected from start survey page if workflow enabled
    currentStepId:number;
    currentStep:WorkflowStepAssignedView;

  //  workflowInstance:WorkflowInstance[]=[];
     
  userActivityLog? : UserActivityLogModel;

}

